module.exports = __webpack_public_path__ + "img/mexico.d51f402e.svg";